import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OptionModel } from '../../models/option';

@Component({
  selector: 'search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent implements OnInit {

  @Input() id!: string;
  @Input() placeholder!: string;
  @Input() label!: string;
  @Input() formGroup!: FormGroup;
  @Input() optionList!: OptionModel[];
  @Input() showAddItem!: boolean;
  @Output() onValueChange = new EventEmitter<string>();
  @Input() hideClear!: boolean;
  @Input() readonly!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onValueChangeHandler() {
    this.onValueChange.emit(this.formGroup.get(this.id)?.value);
  }
}
